<template>
    <div class="main">
        <div class="main-blue">
            <img class="main-blue-background" src="@img/header.png">
            <main-user-info-view class="main-blue-user-info"></main-user-info-view>
        </div>
        <div class="main-white">
            <!-- <health-file-view @onItemClick="onClick"></health-file-view> -->
            <main-list @onCellClick="onClick"></main-list>
        </div>
    </div>
</template>

<script>
import MainUserInfoView from "@/components/wxmain/MainUserInfoView.vue";
import MainList from "@/components/wxmain/MainList.vue";
export default {
    components: {
        MainUserInfoView,
        MainList,
    },
    data() {
        return {
        };
    },
    methods: {
        onClick(title) {
            switch (title) {
                case "报告记录":
                    this.openReportRecord()
                    break
                case "用户协议":
                    this.openProtocolPage()
                    break;
                case "隐私协议":
                    this.openPrivacyPage()
                    break;
                case "退出登录":
                    this.logout()
                    break
                default:

            }
        },
        openReportRecord() {
            this.$router.push({ name: 'Record' })
        },
        openProtocolPage() {
            window.open("https://bajiesleep.cn/bjyonghuxieyi.html", "_blank");
        },
        openPrivacyPage() {
            window.open("https://bajiesleep.cn/bjyinsixieyi.html", "_blank");
        },

        logout() {
            this.$store.dispatch('user/clearUser')
            this.$router.replace({name: 'Login'})
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    position: relative;
    background-color: #F7F7F7;
    height: 100%;
    &-blue {
        z-index: 1;
        position: fixed;

        &-background {
            width: 100%;
        }

        &-user-info {
            position: absolute;
            display: flex;
            align-items: center;
            top: 62px;
            left: 31px;
        }
    }

    &-white {
        position: absolute;
        top: 55px;
        box-sizing: border-box;
        width: 100%;
        padding: 62px 16px 0px;
    }
}
</style>